var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("transition", { attrs: { name: "transition-scale-fade" } }, [
    _c(
      "div",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.noPreferencesAndGdpr || _vm.isShowingManagement,
            expression: "noPreferencesAndGdpr || isShowingManagement",
          },
        ],
        staticClass: "modal",
        staticStyle: { "--modal-zindex": "var(--depth-3)" },
      },
      [
        _c(
          "div",
          {
            staticClass:
              "transition-scale-fade-content yellow position-absolute bottom-0 left-0 column-12 tablet:column-7 laptop:column-5 desktop:column-4 padding-lg",
            staticStyle: { background: "transparent", visibility: "visible" },
            attrs: { id: "cookie-consent" },
          },
          [
            _c(
              "div",
              {
                staticClass:
                  "card header roomy text-left with-border margin-bottom-0",
                staticStyle: { "--border-color": "var(--fa-dk-yellow)" },
              },
              [
                _c(
                  "h2",
                  { staticClass: "h4" },
                  [
                    _c("font-awesome-icon", {
                      staticClass: "margin-right-2xs",
                      attrs: { icon: _vm.$v7.solid.faCookieBite, size: "xl" },
                    }),
                    _vm._v("\n          Cookie. Cookie. Cookie.\n        "),
                  ],
                  1
                ),
                _vm._v(" "),
                _c("p", [
                  _vm._v(
                    "\n          We use cookies to make our site work better by storing limited information about your usage of the site.\n          "
                  ),
                  _c(
                    "a",
                    {
                      staticClass: "blue",
                      attrs: {
                        href: "https://github.com/FortAwesome/Security-Docs-and-Attestation/blob/main/Font_Awesome_Cookie_Info.md",
                        target: "_blank",
                      },
                    },
                    [_vm._v("Read more here.")]
                  ),
                ]),
                _vm._v(" "),
                _vm.isShowingCookieOptions
                  ? _c(
                      "div",
                      {
                        staticClass:
                          "margin-bottom-xl display-flex flex-column",
                        staticStyle: { gap: "var(--spacing-2xs)" },
                      },
                      _vm._l(_vm.cookieOptions, function (option, index) {
                        return _c("customize-cookies-checkbox", {
                          key: option.title,
                          attrs: {
                            description: option.description,
                            "is-checked": _vm.cookieIsChecked(option),
                            "is-last": _vm.cookieOptions.length === index + 1,
                            "is-required": option.isRequired,
                            "is-showing-description":
                              option.isShowingDescription,
                            title: option.title,
                          },
                          on: {
                            showCookieDescription: _vm.showCookieDescription,
                            change: (value) =>
                              _vm.cookiePreferenceChange(option, value),
                          },
                        })
                      }),
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _c("div", { staticClass: "row margin-y-xs" }, [
                  _c("div", { staticClass: "column" }, [
                    _c(
                      "button",
                      {
                        staticClass: "compact block flat clear with-border",
                        staticStyle: {
                          "--button-color": "var(--fa-navy)",
                          "border-color": "var(--fa-navy)",
                        },
                        on: { click: _vm.declineAll },
                      },
                      [_vm._v("\n              Necessary Only\n            ")]
                    ),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "column" }, [
                    _c(
                      "button",
                      {
                        staticClass: "compact block flat clear with-border",
                        staticStyle: {
                          "--button-color": "var(--fa-navy)",
                          "border-color": "var(--fa-navy)",
                        },
                        on: { click: _vm.showSaveOption },
                      },
                      [
                        _vm._v(
                          "\n              " +
                            _vm._s(_vm.actionText) +
                            "\n            "
                        ),
                      ]
                    ),
                  ]),
                ]),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "block primary",
                    staticStyle: {
                      "--button-hover-background": "var(--fa-dk-yellow)",
                    },
                    on: { click: _vm.acceptAll },
                  },
                  [
                    _c("font-awesome-icon", {
                      staticClass: "padding-right-2xs",
                      attrs: { icon: _vm.$v7.solid.faCookieBite, size: "xl" },
                    }),
                    _vm._v("\n          Accept All Cookies\n        "),
                  ],
                  1
                ),
              ]
            ),
          ]
        ),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }